var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 65,
    viewBox: "0 0 50 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6784 0.106934H31.528C32.0474 0.106934 32.5456 0.320464 32.9129 0.700551L49.234 17.59C49.6013 17.9701 49.8077 18.4856 49.8077 19.0231V56.1799C49.8077 58.5092 48.9135 60.7431 47.3219 62.3901C45.7303 64.0372 43.5716 64.9625 41.3207 64.9625H8.6784C6.42751 64.9625 4.26881 64.0372 2.67719 62.3901C1.08557 60.7431 0.191406 58.5092 0.191406 56.1799V8.88945C0.191406 6.56018 1.08557 4.32632 2.67719 2.67927C4.26881 1.03223 6.42751 0.106934 8.6784 0.106934ZM31.528 4.9999L45.7322 19.6987H32.8337C32.4874 19.6987 32.1553 19.5564 31.9104 19.303C31.6656 19.0496 31.528 18.7059 31.528 18.3476V4.9999ZM23.6146 27.7237C24.3795 26.9322 25.6196 26.9322 26.3844 27.7237L36.1771 37.8574C36.942 38.6489 36.942 39.9321 36.1771 40.7236C35.4123 41.5151 34.1722 41.5151 33.4073 40.7236L26.9581 34.0498V49.4242C26.9581 50.5435 26.0812 51.4509 24.9995 51.4509C23.9179 51.4509 23.041 50.5435 23.041 49.4242V34.0498L16.5917 40.7236C15.8269 41.5151 14.5868 41.5151 13.822 40.7236C13.0571 39.9321 13.0571 38.6489 13.822 37.8574L23.6146 27.7237Z",
    fill: "#1769FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/FileUpload.36028a01.svg";
export { ForwardRef as ReactComponent };